import styled from 'styled-components';
import LoadingComponent from '../../../shared/LoadingComponent/LoadingComponent.jsx';
import Boards from './Boards.jsx';

const BoardsWrapper = styled.div`
  border-radius: 8px;
  width: 98vw;
  background-color: white;
  right: -12px;
  top: 35px;
  position: absolute;
  box-shadow: 0px 4px 8px rgba(37, 40, 43, 0.24);
  margin: 14px 0 0;
  display: flex;
  flex-direction: column;
  z-index: 3;
`;

const BoardsArea = ({ boards, isLoading }) => (
  <BoardsWrapper>
    {isLoading ? (
      <LoadingComponent marginBottom="50px" />
    ) : (
      <Boards boards={boards} excludeCloseIcon={true} />
    )}
  </BoardsWrapper>
);

export default BoardsArea;
